import React from "react";
import "./App.css";
import { Switch, HashRouter as Router, Route } from "react-router-dom";
import Login from "./Components/Login/Login";
import Main from "./Components/Menu/Menu_List";
import { ToastContainer, toast } from "react-toastify";
import Forgetpass from "./Components/Login/Forgetpass";
import RecoverPass from "./Components/Login/PassRecovery";
import PrivateRoute from "./PrivateRoute";

export default function App() {
  return (
    <div>
      <Route exact path="/" component={Login} />
      <Route exact path="/login" component={Login} />

      <Route exact path="/forgetpass" component={Forgetpass} />
      <Route exact path="/passrecovery" component={RecoverPass} />

      <PrivateRoute path="/main">
        <Main />
      </PrivateRoute>

      <ToastContainer position={toast.POSITION.BOTTOM_LEFT} autoClose={5000} />
    </div>
  );
}
